import { defineComponent as _defineComponent } from 'vue'
import { DateSelector } from 'ah-common-lib/src/common/components';
import MaterialIcon from '../common/MaterialIcon.vue';

// TODO refactor DateSelector to composition API , expose props directly (instead of using $attrs)

export default /*#__PURE__*/_defineComponent({
  __name: 'DateSelector',
  setup(__props) {


return { __sfc: true,DateSelector, MaterialIcon }
}

})